require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Symbol['for'];


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/symbol/for.js
// module id = 3
// module chunks = 0